import {POST_FCM_SEND_START} from "../../types";

export const fcm_send = (payload) => ({
  type: POST_FCM_SEND_START,
  payload,
});
